import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { breakpoints } from 'app_custom_mufe_revamp/utilities/breakpoints';
const { processAlertMessage } = require('app_custom_mufe_revamp/accessibility/accessibilityHelper');

export const cartRecommendationCarousel = {
    elements: {
        $document: $(document),
    },

    selectors: {
        carousel: '.js-cart-recommendations-carousel',
        carouselBtnNext: '.js-cart-recommendations-btn-next',
        carouselBtnPrev: '.js-cart-recommendations-btn-prev'
    },

    settings: {
        carouselParameters: {
            modules: [Navigation],
            slidesPerView: 1.1,
            mousewheel: true,
            keyboard: true,
            spaceBetween: 10,
            autoHeight: true,
            breakpoints: {
                [breakpoints.desktop]: { slidesPerView: 1.13 }
            },
            on: {
                slideChangeTransitionEnd(swiper) {
                    processAlertMessage('Showing recommended products carousel slide ' + (swiper.realIndex + 1), true);
                }
            }
        }
    },

    state: {
        swipers: []
    },

    init() {
        this.initObserver();
    },

    initObserver() {
        // Observe  js-cart-recommendations-carousel each time it's added to the DOM log 'updating carousel'
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            const $node = $(node);
                            const $carousels = $node.is(this.selectors.carousel) ? $node : $node.find(this.selectors.carousel);
                            if ($carousels.length > 0) {
                                this.refreshCarousel($carousels);
                            }
                        }
                    });
                }
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    },

    initCarousel($carousels) {
        // Initialize every newly added carousel element directly (no dialog ancestor lookup needed)
        $carousels.each((i, carouselEl) => {
            // Find navigation buttons inside this carousel
            const nextBtn = $(carouselEl).find(this.selectors.carouselBtnNext)[0];
            const prevBtn = $(carouselEl).find(this.selectors.carouselBtnPrev)[0];

            // Clone settings and set navigation for this carousel
            const params = {
                ...this.settings.carouselParameters,
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn
                }
            };

            // Initialize Swiper
            const swiperInstance = new Swiper(carouselEl, params);

            // Mark as initialized
            $(carouselEl).attr('data-swiper-initialized', true);

            // Store instance
            this.state.swipers.push(swiperInstance);
        });
    },

    destroyCarousels() {
        // Only clean up instances whose element was actually removed from the
        // DOM (e.g. replaced by a fresh AJAX render). Carousels still attached
        // in another open dialog (mini-cart vs. cart) are left untouched.
        this.state.swipers = this.state.swipers.filter(swiper => {
            const isAttached = document.body.contains(swiper.el);
            if (!isAttached && swiper.destroy) swiper.destroy(true, true);
            return isAttached;
        });
    },

    refreshCarousel($carousels) {
        // Clean up only stale/detached carousels
        this.destroyCarousels();

        // Initialize new ones
        this.initCarousel($carousels);
    }
};

cartRecommendationCarousel.init();